import { SafeUrl } from "@angular/platform-browser";
import { BaseModel } from "./base-model";
import { Picture } from "./picture";
export class Discover extends BaseModel {
  titleFr: string;
  titleEn: string;
  distance: string;
  duration: string;
  distanceDuration: string;
  descriptionFr: string;
  descriptionEn: string;
  umapUrlFr: string;
  umapUrlEn: string;
  picture: Picture;
  pictures: Picture[];
  safeUrl: SafeUrl;
  gpxUrl: string;
  videoUrl: string;
}
